import { render, staticRenderFns } from "./AddManualAttendence.vue?vue&type=template&id=97f0dbd2&"
import script from "./AddManualAttendence.vue?vue&type=script&lang=js&"
export * from "./AddManualAttendence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports